import React, { useState } from "react";
import styles from "./styles.module.scss";
import { ElectricityUseSlideType } from "../../../types/electicityUseSlide";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";

interface ElectricityUseSlideProps {
  data: ElectricityUseSlideType;
  onNavigation: OnNavigationType;
}

const ElectricityUseSlide: React.FC<ElectricityUseSlideProps> = ({ data, onNavigation }) => {
  const [people, setPeople] = useState<number>(1);
  const [consumption, setConsumption] = useState<number | string>();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [tariff, setTariff] = useState<number>(35);
  const [monthlyCost, setMonthlyCost] = useState<number>(65);

  const handleItemChange = (itemValue: string) => {
    setSelectedItems((prevSelectedItems) => {
      if (itemValue === "none") {
        return prevSelectedItems.includes("none") ? [] : ["none"];
      }
      let updatedSelections = prevSelectedItems.filter(
        (value) => value !== "none"
      );
      if (updatedSelections.includes(itemValue)) {
        updatedSelections = updatedSelections.filter(
          (value) => value !== itemValue
        );
      } else {
        updatedSelections = [...updatedSelections, itemValue];
      }
      return updatedSelections;
    });
  };

  const handleIncrease = () => {
    setPeople(people + 1);
    setConsumption((people + 1) * 1500);
  };

  const handleDecrease = () => {
    if (people > 1) {
      setPeople(people - 1);
      setConsumption((people - 1) * 1500);
    }
  };

  // const handleSubmit = () => {
  //   console.log("Submitted values:", {
  //     people,
  //     consumption,
  //     selectedItems,
  //     tariff,
  //     monthlyCost,
  //   });
  // };

  return (
    <>
      <div className={styles.electricityUseSlide}>
        <p className={styles.description}>{data.subtitle}</p>
        {/* Step 1: Number of Residents */}
        <h2 className={styles.title}>{data.step1NumberOfResidents.title}</h2>
        <div className={styles.counter}>
          <button className={styles.counterBtn} onClick={handleDecrease}>
            -
          </button>
          <div className={styles.counterValue}>
            {people}
            <img
              src="/people.svg"
              alt="people-svg"
              className={styles.peopleSvg}
            />
          </div>
          <button className={styles.counterBtn} onClick={handleIncrease}>
            +
          </button>
        </div>
        <label className={styles.required}>
          {
            data.step1NumberOfResidents.yearlyConsumptionInput.errorMessages
              .required
          }
        </label>
        <div className={styles.consumption}>
          <label>{data.step1NumberOfResidents.consumptionEstimateLabel}</label>
          <input
            type="text"
            className={styles.consumptionInput}
            value={consumption}
            onChange={(e) => setConsumption(e.target.value)}
          />
          <span className={styles.unit}>
            {data.step1NumberOfResidents.yearlyConsumptionInput.kWhLabel}
          </span>
        </div>
        <label className={styles.maxError}>
          {consumption && consumption > "3000"
            ? data.step1NumberOfResidents.yearlyConsumptionInput.errorMessages
                .max
            : ""}
        </label>
        <label className={styles.maxError}>
          {consumption && consumption < "1000"
            ? data.step1NumberOfResidents.yearlyConsumptionInput.errorMessages
                .min
            : ""}
        </label>

        {/* Step 2: Consumption Items */}
        <h2 className={styles.title}>{data.step2ConsumptionItems.title}</h2>
        <p className={styles.estimatedConsumption}>
          {data.step2ConsumptionItems.apiFieldName}
        </p>
        <div className={styles.consumptionItemsGrid}>
          {data.step2ConsumptionItems.consumptionItems.map((item) => (
            <div
              key={item.value}
              className={`${styles.consumptionItem} ${
                selectedItems.includes(item.value) ? styles.active : ""
              }`}
              onClick={() => handleItemChange(item.value)}>
              <label>{item.label}</label>
            </div>
          ))}
        </div>

        {/* Step 3: Monthly Cost */}

        <h2 className={styles.title}>{data.step3MonthlyCost.title}</h2>
        <div className={styles.monthlyCost}>
          <div className={styles.inputGroup}>
            <label>{data.step3MonthlyCost.yearlyConsumptionInput.label}</label>
            <div className={styles.inputWrapper}>
              <input
                type="number"
                value={consumption}
                onChange={(e) => setConsumption(parseFloat(e.target.value))}
                className={styles.costInput}
              />
              <span className={styles.yearlyUnit}>
                {data.step3MonthlyCost.yearlyConsumptionInput.kWhLabel}
              </span>
              <button className={styles.editIcon}>
                <img src="/pencil.svg" alt="pencil-icon" width={15} />
              </button>
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label>{data.step3MonthlyCost.tarrifCostInput.label}</label>
            <div className={styles.inputWrapper}>
              <input
                type="number"
                value={tariff}
                onChange={(e) => setTariff(parseFloat(e.target.value))}
                className={styles.costInput}
              />
              <span className={styles.yearlyUnit}>
                {data.step3MonthlyCost.tarrifCostInput.ctPerKwhLabel}
              </span>
              <button className={styles.editIcon}>
                <img src="/pencil.svg" alt="pencil-icon" width={15} />
              </button>
            </div>
          </div>

          <div className={styles.monthlyCostDisplay}>
            <span className={styles.monthlyCostValue}>{monthlyCost}</span>
            {data.step3MonthlyCost.monthlyCostInput.perMonthLabel}
          </div>

          <button className={styles.editButton}>
            {data.step3MonthlyCost.updateValuesButtonLabel}
          </button>
        </div>
      </div>
      <SlideNavigation
        onNavigation={() => onNavigation(1)}
        nextText={"Next"}
        selected={[12]}
      />
    </>
  );
};

export default ElectricityUseSlide;
